import React from "react";
import { Navigate } from "react-router-dom";
import { BordonaDashboardView } from "../components/dashboard/BordonaDashboardView";
import { TeacherDashboardView } from "../components/dashboard/TeacherDashboardView";
import { useBordonaAccount } from "../hooks/useBordonaAccount";

export const HomePage: React.FC = () => {
  const { role, isLoading, isAuthenticated } = useBordonaAccount();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1c1a19]">
        <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-[#c9405a] animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (role === "teacher") {
    return <TeacherDashboardView />;
  }

  return <BordonaDashboardView />;
};

export default HomePage;
